export default {
  namespaced: true,
  state: {
    // 処理中判定
    count: 0,
    // 画面遷移中判定(router.jsで処理)
    isRouting: true,
    // 遷移先情報
    to: undefined
  },
  mutations:{
    countUp(state){
      state.count += 1
    },
    countDown(state){
      state.count -= 1
    },
    isRouting(state, boole){
      state.isRouting = boole
    },
    saveTo(state, to){
      state.to = to
    }
  }
}